import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortCompareLowHighState } from "./QuickSortCompareLowHighState";
import { QuickSortCallEnvironment } from "../../stack/QuickSortCallEnvironment";
import { QuickSortRightRecursionCallState } from "./QuickSortRightRecursionCallState";


export class QuickSortReturnState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortReturn;
  
  Description = "Return from Quick Sort Call";

  private _savedState : { 
    ComparisonResult: boolean,
    SavedPartitionIndex: number | undefined,
    SavedLo: number | undefined,
    SavedHi: number | undefined,
    PoppedQuickSortCallEnvironment: QuickSortCallEnvironment | undefined
  } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Lo);
    assertIsDefined(this._context.Hi);
    assertIsDefined(this._context.AlgoStack);    

    //
    // Save current lo hi partition index environment
    //

    let savedPartitionIndex : number | undefined = this._context.PartitionIndex;
    let savedLo : number | undefined = this._context.Lo;
    let savedHi : number | undefined = this._context.Hi;

    //
    // Pop QuickSortCallEnvironment from stack
    //

    let poppedQuickSortCallEnvironment : QuickSortCallEnvironment | undefined = this._context.AlgoStack.pop() as QuickSortCallEnvironment;

    //
    // we need to add index to sorted indices if lo === hi
    //

    let comparisonResult = this._context.Lo === this._context.Hi;

    if (comparisonResult) {
      this._context.SortedIndices?.push(this._context.Lo);
    }

    if (this._savedState === undefined) {
      this._savedState = {
        ComparisonResult: comparisonResult,
        SavedPartitionIndex: savedPartitionIndex,
        SavedLo: savedLo,
        SavedHi: savedHi,
        PoppedQuickSortCallEnvironment: poppedQuickSortCallEnvironment
      }
    }
    else {
      this._savedState.ComparisonResult = comparisonResult;
      this._savedState.SavedPartitionIndex = savedPartitionIndex;
      this._savedState.SavedLo = savedLo;
      this._savedState.SavedHi = savedHi;
      this._savedState.PoppedQuickSortCallEnvironment = poppedQuickSortCallEnvironment;
    }

    //
    // restore the environment
    // 

    this._context.PartitionIndex = poppedQuickSortCallEnvironment.CallerPartitionIndex;
    this._context.Lo = poppedQuickSortCallEnvironment.CallerLo;
    this._context.Hi = poppedQuickSortCallEnvironment.CallerHi;
  }

  Undo(): void {
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.ComparisonResult);
    assertIsDefined(this._context);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._context.SortedIndices);

    //
    // saved comparison result
    //

    if (this._savedState.ComparisonResult && this._savedState.SavedLo !== undefined) {
      let foundIndex = this._context.SortedIndices.indexOf(this._savedState.SavedLo);
      if (foundIndex >= 0) {
        let left = this._context.SortedIndices.slice(0, foundIndex);
        let right = this._context.SortedIndices.slice(foundIndex + 1);
        this._context.SortedIndices = [...left, ...right];
      }
    }

    // 
    // push stuff back to stack
    //

    this._context.AlgoStack.push(this._savedState.PoppedQuickSortCallEnvironment);

    //
    // restore environment state
    //

    this._context.PartitionIndex = this._savedState.SavedPartitionIndex;
    this._context.Lo = this._savedState.SavedLo;
    this._context.Hi = this._savedState.SavedHi;
  }

  Exit(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.ComparisonResult);
    assertIsDefined(this._context.AlgoStack);
    // if (this._savedState.ComparisonResult) {
    //   //
    //   // maybe push to sorted indices ???
    //   //
    //   this._context.TransitionTo(new QuickSortCompareLowHighState());
    // }

    if (this._context.AlgoStack.length === 0) {
      this._context.IsEnd = true;
      return;
    }

    if (this._savedState.PoppedQuickSortCallEnvironment?.CallerStep === QuickSortStep.QuickSortCall) {
      //
      // hm.. another quickSortCall
      //
      this._context.TransitionTo(new QuickSortReturnState());
    }
    else if (this._savedState.PoppedQuickSortCallEnvironment?.CallerStep === QuickSortStep.QuickSortLeftRecursionCall) {
      //
      //
      //
      this._context.TransitionTo(new QuickSortRightRecursionCallState());
    }
    else if (this._savedState.PoppedQuickSortCallEnvironment?.CallerStep === QuickSortStep.QuickSortRightRecursionCall) {
      //
      //
      //
      this._context.TransitionTo(new QuickSortReturnState());
    }
  }
}